import { createShipIcon } from "@components/map/mapComponents/shipIcon"
import { updateSidePanelState } from "@redux/features/mapSidePanelControl/mapSidePanelControlSlice"
import { setSelectedVessel } from "@redux/features/selectedVessel/selectedVesselSlice"
import type { LatLng } from "leaflet"
import { DataSetter } from "../utils/mapLayers"
import { getVesselDisplayName } from "../utils/vesselMetadata"
import { getWorldCopyLongitudeOffsets, getWorldCopyPoints } from "./vesselTrackMapEdges"

export const addVessels: DataSetter = (
	dispatch,
	queryClient,
	layerGroup,
	layerData,
	navigate,
	map
) => {
	if (layerGroup === undefined) return

	const { vesselsData } = layerData
	if (vesselsData === undefined) return

	const { company, vesselInfo } = vesselsData
	if (vesselInfo.length === 0) return

	layerGroup.clearLayers()
	const longitudeOffsets = getWorldCopyLongitudeOffsets(map?.getBounds())

	for (const ship of vesselInfo) {
		if (ship?.position?.lat === undefined || ship?.position?.lon === undefined) {
			continue
		}
		if (isNaN(ship.position.lat) === true || isNaN(ship.position.lon) == true) {
			continue
		}
		const shipCoords: LatLng[] = getWorldCopyPoints(
			{
				latitude: ship.position.lat,
				longitude: ship.position.lon,
			},
			longitudeOffsets
		).map((point) => L.latLng(point.latitude, point.longitude))

		const vesselDisplayName = getVesselDisplayName(ship, company)

		for (const shipCoord of shipCoords) {
			layerGroup.addLayer(
				L.marker(shipCoord, {
					icon: createShipIcon({
						heading: ship.position.heading,
						latestOperationMode: ship.latestOperationMode,
					}),
					pane: "vesselsPane",
				})
					.bindTooltip(vesselDisplayName, { permanent: true })
					.on("click", () => {
						if (ship !== null) {
							dispatch(setSelectedVessel({ ...ship, name: vesselDisplayName }))
							dispatch(
								updateSidePanelState({
									isTableExpanded: false,
									isOpen: true,
									selectedTab: "1",
								})
							)
							if (navigate !== undefined) {
								navigate({
									to: `.`,
									search: (prev) => ({ ...prev, vessel: vesselDisplayName }),
								})
							}
						}
					})
			)
		}
	}
}
